export default __webpack_public_path__ + "static/media/womenShortTrousers.2fbf1250.svg";